import { useSelector } from "react-redux";
import { IThemeState } from "../store/reducers";
import medquestLogo from "../assets/images/mq-logo.png";
import belmarLogo from "../assets/images/bq-logo.png";
import belmarSignInLogo from "../assets/images/belmar-logo.png";
import { Link } from "react-router-dom";

const logoMap = {
    'Belmar': belmarSignInLogo,
    //'Medquest': medquestLogo,
};

const headerMap = {
    'Belmar': belmarLogo,
    'Medquest': medquestLogo,
}


export const SignInLogo = () => {
    const tenant:IThemeState = useSelector((state: any) => state.tenantConfig);
    const logoSrc = (logoMap as any)[tenant.Name]; 
    if(!logoSrc) {
        return null;
    }
    
    return (
        <div className="sign-in-logo" style={{textAlign: 'center'}}>
            <img height='59.5px' src={logoSrc} alt="Logo" />
        </div>
    )
}

export const HeaderLogo = () => {
    const tenant:IThemeState = useSelector((state: any) => state.tenantConfig);
    const logoSrc = (headerMap as any)[tenant.Name] || medquestLogo; 
        
    return (
        <Link to="/dashboard" style={{display: 'inline-block'}}>
            <img alt={tenant.Name} height='35px' src={logoSrc} />
        </Link>
    )
}

// export const HeaderLogo = () => {
//     const tenant:IThemeState = useSelector((state: any) => state.tenantConfig);
//     const logoSrc = (headerMap as any)[tenant.Name] || medquestLogo; 
        
//     console.log(tenant);
//     return (
//         <div >
//             <img height='35px' src={logoSrc} alt="Logo" />
//         </div>
//     )
// }

